<div class="f-15 fw-600 mb-3">
  <!-- <label for="categoryname*" class="form-label fw-600 Error_text">
    Enter Amount To Refund</label
  > -->
  <ng-container *ngIf="checkProductSelected()">
    <input
      class="form-control text-start modal_input_theme"
      #currency
      readonly="true"
      currencyMask
      [(ngModel)]="totalPartialRefund"
      [options]="{ prefix: nCurrency, decimal: '.' }"
      placeholder="{{ nCurrency + '0.00' }}"
      [readOnly]="true"
    />
  </ng-container>
  <ng-container *ngIf="!checkProductSelected()">
    <input
      class="form-control text-start"
      #currency
      (ngModelChange)="change(currency)"
      currencyMask
      [(ngModel)]="totalPartialRefund"
      [options]="{ prefix: nCurrency, decimal: '.' }"
      placeholder="{{ nCurrency + '0.00' }}"
      [readOnly]="!cRefundModalPageOne?true:false"
    />
  </ng-container>
</div>
<span class="text-danger f-w-5">{{ errorMsg | translate | async }}</span>
<!-- <div class="divider f-14 fw-700 text-center mb-4">
  <span> OR </span>
  <div class="line"></div>
</div> -->
<p class="text-center mb-3">{{ "OR" | translate | async }}</p>

<ng-container *ngIf="cRefundModalPageOne && !checkProductSelected()">
  <div class="mb-2">
    <select id="transactionDropdown" class="form-select" [(ngModel)]="selectedTransaction" (change)="onTransactionSelect(selectedTransaction)">
      <option [ngValue]="null">{{ "Select Transaction" | translate | async }}</option>
      <option *ngFor="let txn of transactionsForDropdown" [ngValue]="txn" [selected]="txn.transactionId === selectedTransactionId">
        <span>
          <ng-container
            [ngSwitch]="txn.transactionTypeId"
            class=""
          >
            <span *ngSwitchCase="1">{{ "Cash" | translate | async }}</span>
            <span *ngSwitchCase="2">{{ "Cheque Payment" | translate | async }} </span>
            <span *ngSwitchCase="3">BruinCard</span>
            <span *ngSwitchCase="5">UCLA Blood</span>
            <span *ngSwitchCase="6">UCLA Career</span>
            <span *ngSwitchCase="7">UCLA Dorm</span>
            <span *ngSwitchCase="8">UCLA Emp</span>
            <span *ngSwitchCase="9">UCLA Meal</span>
            <span *ngSwitchCase="10">UCLA Parent</span>
            <span *ngSwitchCase="11">UCLA Events</span>
            <span *ngSwitchCase="12">GC Promotion</span>
            <span *ngSwitchCase="13">GrubHub</span>
            <span *ngSwitchCase="14">Uber Eats</span>
            <span *ngSwitchCase="15">Account</span>
            <span *ngSwitchCase="16">CardConnect</span>
            <span *ngSwitchCase="17">Datacap</span>
            <span *ngSwitchCase="18">CreditCall</span>
            <span *ngSwitchCase="19">Uno</span>
            <span *ngSwitchCase="20">Square</span>
            <span *ngSwitchCase="26">Doordash</span>
            <span *ngSwitchCase="27">Blizzful</span>
            <span *ngSwitchCase="29">Clover</span>
            <span *ngSwitchCase="31">eCard</span>
            <span *ngSwitchCase="32">Online Order</span>
            <span *ngSwitchCase="33">Voucherify</span>
            <span *ngSwitchCase="35">External CC</span>
            <span *ngSwitchCase="37">TotalPay</span>
            <span *ngSwitchDefault>{{ "None" | translate | async }}</span>
          </ng-container>
        </span> - <span>{{ nCurrency }}{{ txn.transactionAmount }}</span>
      </option>
    </select>
  </div>
</ng-container>
